import { handleFetchPredictionDatasets, handleFetchValidDatasets } from "../../modules/datasetModule.ts";
import { handleCreatePredictor } from "../../modules/predictorModule.ts";

export const handleSubmit = async (setIsLoading, formData, navigate, toast) => {
  try {
    setIsLoading(true);
    sessionStorage.setItem("createPredictorForm", JSON.stringify(formData));
    formData = {
      ...formData,
      predictor_name: formData.predictor_name.trim(),
      ...(formData.problem_type === "Unsupervised Learning" && {problem_type: "UnsupervisedLearning", shap_enabled: true})
    }
    const response = await handleCreatePredictor(formData);
    toast.success("Predictor created successfully!");

    navigate("/TrainPredictor");
  } catch (error) {
    console.error("Failed to create predictor:", error);
    toast.error(`Failed to create predictor: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};

export const loadDatasets = async (setIsLoadingDatasets, setDatasets) => {
  try {
    setIsLoadingDatasets(true);
    const response = await handleFetchValidDatasets();
    setDatasets(response);
  } catch (error) {
    console.error("Failed to load datasets:", error);
  } finally {
    setIsLoadingDatasets(false);
  }
};

export const loadPredictionDataset = async (setIsLoadingDatasets, setDatasets, dataset_id) => {
  try {
    setIsLoadingDatasets(true);
    const response = await handleFetchPredictionDatasets(dataset_id);
    setDatasets(response);
  } catch (error) {
    console.error("Failed to load datasets:", error);
  } finally {
    setIsLoadingDatasets(false);
  }
}

export const handleInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  setFormData,
  problemTypeOptions
) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    if (name === "domain") {
      return {
        ...prev,
        domain: value,
        problem_type: problemTypeOptions[value][0],
      };
    }
    return {
      ...prev,
      [name]: value,
    };
  });
};
